/* =====================================================
   NAV.JS — Hamburger toggle, active state, dropdowns
   ===================================================== */

(function () {
  const nav = document.querySelector('.nav');
  const hamburger = document.querySelector('.nav__hamburger');
  const mobileMenu = document.querySelector('.nav__mobile-menu');

  if (!hamburger || !nav) return;

  // ── Hamburger toggle ──────────────────────────────
  hamburger.addEventListener('click', function () {
    const isOpen = nav.classList.toggle('nav-open');
    hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });

  // ── Close mobile menu on link click ──────────────
  if (mobileMenu) {
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        nav.classList.remove('nav-open');
        hamburger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  // ── Desktop dropdown toggles ──────────────────────
  document.querySelectorAll('.nav__dropdown-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      const item = toggle.closest('.nav__item--has-dropdown');
      const isOpen = item.classList.contains('dropdown-open');

      // Close all other dropdowns
      closeAllDropdowns();

      if (!isOpen) {
        item.classList.add('dropdown-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ── Mobile accordion group toggles ───────────────
  document.querySelectorAll('.nav__mobile-group-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      const group = toggle.closest('.nav__mobile-group');
      const isOpen = group.classList.contains('group-open');

      // Close all other mobile groups
      document.querySelectorAll('.nav__mobile-group.group-open').forEach(function (el) {
        el.classList.remove('group-open');
        el.querySelector('.nav__mobile-group-toggle').setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        group.classList.add('group-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ── Close on outside click ────────────────────────
  document.addEventListener('click', function (e) {
    if (nav.classList.contains('nav-open') && !nav.contains(e.target)) {
      nav.classList.remove('nav-open');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    if (!nav.contains(e.target)) {
      closeAllDropdowns();
    }
  });

  // ── Close on Escape ───────────────────────────────
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (nav.classList.contains('nav-open')) {
        nav.classList.remove('nav-open');
        hamburger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
      closeAllDropdowns();
    }
  });

  function closeAllDropdowns() {
    document.querySelectorAll('.nav__item--has-dropdown.dropdown-open').forEach(function (el) {
      el.classList.remove('dropdown-open');
      el.querySelector('.nav__dropdown-toggle').setAttribute('aria-expanded', 'false');
    });
  }
})();
